/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sellers_Meta_Notfounddescription2Inputs */

const id_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual tidak ditemukan`)
};

const ms_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual tidak ditemui`)
};

const da_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælger ikke fundet`)
};

const de_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer nicht gefunden`)
};

const en_us2_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller not found`)
};

const es_es2_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor no encontrado`)
};

const es_mx2_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor no encontrado`)
};

const fil_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang nagbebenta`)
};

const fr_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur non trouvé`)
};

const it_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditore non trovato`)
};

const hu_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladó nem található`)
};

const nl_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkoper niet gevonden`)
};

const no_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selger ikke funnet`)
};

const pl_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca nie znaleziony`)
};

const pt_br2_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor não encontrado`)
};

const pt_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor não encontrado`)
};

const ro_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzător negăsit`)
};

const fi_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjää ei löydy`)
};

const sv_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljaren hittades inte`)
};

const vi_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy người bán`)
};

const tr_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı bulunamadı`)
};

const cs_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejce nenalezen`)
};

const bg_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавачът не е намерен`)
};

const ru_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец не найден`)
};

const uk_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавця не знайдено`)
};

const ar_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البائع غير موجود`)
};

const hi_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता नहीं मिला`)
};

const th_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผู้ขาย`)
};

const ja_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元が見つかりません`)
};

const zh_cn2_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发行商未找到`)
};

const zh_hant1_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發行商未找到`)
};

const ko_sellers_meta_notfounddescription2 = /** @type {(inputs: Sellers_Meta_Notfounddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Seller not found" |
*
* @param {Sellers_Meta_Notfounddescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_meta_notfounddescription2 = /** @type {((inputs?: Sellers_Meta_Notfounddescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Meta_Notfounddescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_meta_notfounddescription2(inputs)
	if (locale === "ms") return ms_sellers_meta_notfounddescription2(inputs)
	if (locale === "da") return da_sellers_meta_notfounddescription2(inputs)
	if (locale === "de") return de_sellers_meta_notfounddescription2(inputs)
	if (locale === "en-US") return en_us2_sellers_meta_notfounddescription2(inputs)
	if (locale === "es-ES") return es_es2_sellers_meta_notfounddescription2(inputs)
	if (locale === "es-MX") return es_mx2_sellers_meta_notfounddescription2(inputs)
	if (locale === "fil") return fil_sellers_meta_notfounddescription2(inputs)
	if (locale === "fr") return fr_sellers_meta_notfounddescription2(inputs)
	if (locale === "it") return it_sellers_meta_notfounddescription2(inputs)
	if (locale === "hu") return hu_sellers_meta_notfounddescription2(inputs)
	if (locale === "nl") return nl_sellers_meta_notfounddescription2(inputs)
	if (locale === "no") return no_sellers_meta_notfounddescription2(inputs)
	if (locale === "pl") return pl_sellers_meta_notfounddescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_meta_notfounddescription2(inputs)
	if (locale === "pt") return pt_sellers_meta_notfounddescription2(inputs)
	if (locale === "ro") return ro_sellers_meta_notfounddescription2(inputs)
	if (locale === "fi") return fi_sellers_meta_notfounddescription2(inputs)
	if (locale === "sv") return sv_sellers_meta_notfounddescription2(inputs)
	if (locale === "vi") return vi_sellers_meta_notfounddescription2(inputs)
	if (locale === "tr") return tr_sellers_meta_notfounddescription2(inputs)
	if (locale === "cs") return cs_sellers_meta_notfounddescription2(inputs)
	if (locale === "bg") return bg_sellers_meta_notfounddescription2(inputs)
	if (locale === "ru") return ru_sellers_meta_notfounddescription2(inputs)
	if (locale === "uk") return uk_sellers_meta_notfounddescription2(inputs)
	if (locale === "ar") return ar_sellers_meta_notfounddescription2(inputs)
	if (locale === "hi") return hi_sellers_meta_notfounddescription2(inputs)
	if (locale === "th") return th_sellers_meta_notfounddescription2(inputs)
	if (locale === "ja") return ja_sellers_meta_notfounddescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_meta_notfounddescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_meta_notfounddescription2(inputs)
	return ko_sellers_meta_notfounddescription2(inputs)
});
export { sellers_meta_notfounddescription2 as "sellers.meta.notFoundDescription" }